import React from 'react';

import campLogo from '../assets/logo-2026.png';
import ucuLogo from '../assets/logo-ucu.png';
import appsLogo from '../assets/logo-apps.png';
import instagramIcon from '../assets/instagram-icon.svg';
import emailIcon from '../assets/email-icon.svg';

export default function Footer() {
  return (
    <footer
      className="
        w-full
        bg-[#170D27]
        font-['Montserrat']
        text-white
      "
    >
      <div
        className="
          container mx-auto
          grid grid-cols-1
          gap-10
          px-6 py-14
          sm:px-8
          md:grid-cols-2
          md:px-16 md:py-16
          lg:grid-cols-[0.9fr_1.2fr_0.9fr_0.9fr]
          lg:items-start
          lg:gap-16
        "
      >
        {/* Логотип табору */}
        <div className="flex items-start">
          <img
            src={campLogo}
            alt="APPS Summer Camp"
            className="h-auto w-[130px] object-contain md:w-[150px]"
          />
        </div>

        {/* За підтримки */}
        <div>
          <h2 className="mb-7 text-xl font-bold md:text-2xl">
            За підтримки
          </h2>

          <div className="flex items-center gap-6">
            <img
              src={ucuLogo}
              alt="Український католицький університет"
              className="h-auto w-[85px] object-contain"
            />

            <img
              src={appsLogo}
              alt="Applied Sciences Faculty"
              className="h-auto w-[110px] object-contain"
            />
          </div>
        </div>

        {/* Site-map */}
        <nav aria-label="Site map">
          <h2 className="mb-7 text-xl font-bold md:text-2xl">
            Maпа сайту
          </h2>

          <ul className="flex flex-col gap-4">
            <li>
              <a
                href="#programs"
                className="
                  text-lg text-white/75
                  transition-colors duration-200
                  hover:text-[#3DFF80]
                "
              >
                Напрямки
              </a>
            </li>

            <li>
              <a
                href="#tickets"
                className="
                  text-lg text-white/75
                  transition-colors duration-200
                  hover:text-[#3DFF80]
                "
              >
                Реєстрація
              </a>
            </li>

            <li>
              <a
                href="#qa"
                className="
                  text-lg text-white/75
                  transition-colors duration-200
                  hover:text-[#3DFF80]
                "
              >
                Q&amp;A
              </a>
            </li>
          </ul>
        </nav>

        {/* Соціальні мережі */}
        <div>
          <h2 className="mb-7 text-xl font-bold md:text-2xl">
            Шукайте нас тут:
          </h2>

          <div className="flex items-center gap-5">
            <a
              href="https://instagram.com/apps.camp.ucu"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram APPS Summer Camp"
              className="
                flex h-16 w-16
                items-center justify-center
                rounded-full
                border-2 border-[#0F081B]
                bg-[#3DFF80]
                transition-transform duration-200
                hover:-translate-y-1
              "
            >
              <img
                src={instagramIcon}
                alt=""
                className="h-8 w-8 object-contain"
              />
            </a>

            <a
              href="mailto:appscamp@ucu.edu.ua"
              aria-label="Написати на електронну пошту"
              className="
                flex h-16 w-16
                items-center justify-center
                rounded-full
                border-2 border-[#0F081B]
                bg-[#3DFF80]
                transition-transform duration-200
                hover:-translate-y-1
              "
            >
              <img
                src={emailIcon}
                alt=""
                className="h-7 w-7 object-contain"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
